export const TRANSACTIONS_STATUSES = [
    { label: 'Pending', value: 'pending', name: 'pending' },
    { label: 'Cancelled', value: 'cancelled', name: 'cancelled' },
    { label: 'Processing', value: 'processing', name: 'processing' },
    { label: 'Error', value: 'error', name: 'error' },
    { label: 'Sent', value: 'sent', name: 'sent' },
    { label: 'Returned', value: 'returned', name: 'returned' },
    { label: 'Quarantined', value: 'quarantined', name: 'quarantined' },
    { label: 'Declined', value: 'declined', name: 'declined' },
]